import { FC, ComponentProps } from 'react';
import { Label as JbcLable } from 'jbc-front/components/presenters/form/Label';
import styles from './Label.scss';

export const Label: FC<ComponentProps<typeof JbcLable>> = ({ children }) => {
  return <JbcLable className={styles.label}>{children}</JbcLable>;
};
